import _ from "underscore";

import { Filter, NumberIdFilter, StringIdFilter, toggleAllElements, toggleElement } from "./index";

export function updateFilterFromIdList(ids: number[], filter: NumberIdFilter): NumberIdFilter
export function updateFilterFromIdList(ids: string[], filter: StringIdFilter): StringIdFilter
export function updateFilterFromIdList(ids: string[] | number[], filter: Filter): Filter {
  const updatedFilter = toggleAllElements(filter, 0);
  return _(ids).reduce((filterSoFar, id) => {
    return toggleElement(id, 1, filterSoFar);
  }, updatedFilter);
}

export default updateFilterFromIdList
